/**
 * @typedef {ReturnType<typeof import('widgets/product/QuickAddToCart').default>} QuickAddToCart
 */

/**
 * @description Base HarmonyProductTile implementation
 * @param {ProductTile} ProductTile widget for extending
 * @returns {typeof HarmonyProductTile} HarmonyProductDetail class
 */
export default function (ProductTile) {
    /**
     * @class HarmonyProductTile
     * @augments ProductTile
     */
    class HarmonyProductTile extends ProductTile {
        init() {
            super.init();

            this.eventBus().on('availability.update', 'availabilityUpdate');
        }

        /**
         * @description update components after availability check on change qty
         * @param {object} params - params
         */
        availabilityUpdate(params) {
            this.renderAvailability(params);
            this.renderAddToCart(params);
        }

        /**
         * @description Render product availability
         * @param {object} params Product object
         * @returns {void}
         */
        renderAvailability(params) {
            if (!params.pid || this.pid !== params.pid) {
                return;
            }

            let message = '';
            let availabilityClass = '';
            let alert = '';

            if (params.availability && (params.availability.isPreorder || params.availability.isBackorder)) {
                if (params.availability.messages) {
                    message = params.availability.messages.join('');
                    availabilityClass = params.availability.class;
                }

                if (params.availability.alerts) {
                    alert = params.availability.alertsCommon.join('');
                }
            }

            this.getById('availability', (availabilityLabel) => {
                availabilityLabel.render('template', {
                    message: message,
                    class: availabilityClass
                }, availabilityLabel.ref('container'));
            });

            this.getById('availabilityAlert', (availabilityAlert) => {
                availabilityAlert.render('template', {
                    alert: alert
                }, availabilityAlert.ref('container'));
            });
        }

        /**
         * @description Render Add to Cart btn
         * @param {object} params - params
         */
        renderAddToCart(params) {
            if (!params.pid || this.pid !== params.pid) {
                return;
            }

            const QuickAddToCart = /** @type {QuickAddToCart} */(this.getConstructor('quickAddToCart'));

            this.eachChild(child => {
                if (child instanceof QuickAddToCart) {
                    child.renderAddToCartText(params);
                }
            });
        }
    }

    return HarmonyProductTile;
}
